import BaoDialog from "../../factories/bao-dialog";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-upload";
import GenericListTab from "./../../factories/generic-list-tab";
import TabPage from "./../../factories/tab-page";
import Bao from "./../../services/bao-service";
import WorkItem from "../work-item";
import * as ko from "knockout";

/**
 * ViewModel for WorkItemRelationTab
 */
class WorkItemRelationTab extends GenericListTab {

    // #region Constructor

    /** 
     *Constructor
     */
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);

        this.Models.subscribe(() => {
            this.Selection([]);
        });
    }

    //  #endregion

    // #region Properties

    // Bao object to access session objects
    Bao = Bao;

    /**
     * Access to parent WorkItem (the "parent" for series elements)
     */
    Parent: WorkItem;

    /**
     * Store the info if the WorkItem is a WorkItem Series 
     */
    InitBasedOnSerialTask: KnockoutObservable<boolean> = ko.observable(false);

    /**
     * Controller Url 
     */
    ControllerUrl = "WorkItemRelationTab";

    // #endregion

    // #region Public Methods

    /**
     * Returns custom filters
     * @returns Custom filters
     */
    CustomFilter(): Models.HashObject[] {
        let customFilterHashObject: Models.HashObject[] = [];
        if (this.InitBasedOnSerialTask()) {
            customFilterHashObject.push({
                Key: 'SourceWorkItemId',
                Value: this.Parent.PrimaryWorkItemId()
            });
            customFilterHashObject.push({
                Key: 'BaseOnSerialTask',
                Value: true
            });
        }
        return customFilterHashObject;
    }

    /**
     * Checks if the view model has been set correctly
     * @returns JqueryPromise<boolean>
     */
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        let def = $.Deferred<boolean>();
        if (item.TargetWorkItemId() && item.WorkItemRelationTypeId()) {
            def.resolve(true);
        }
        else {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            def.resolve(false);
        }       

        return def.promise();
    }

    /**
     * Init
     */
    init = (): JQueryPromise<void> => {
        if (this.Parent.IsBasedOnVirtual()) {
            this.InitBasedOnSerialTask(true);
        }
        return super.init()
            .always(_ => this.InitBasedOnSerialTask(false));
    }

    // #endregion

}
export default WorkItemRelationTab;